require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./histoire-de-lepfl-0-0-1.json") })
        }
      }, "path---histoire-de-lepfl-0-0-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---histoire-de-lepfl-0-0-1!./.cache/json/histoire-de-lepfl-0-0-1.json
// module id = 458
// module chunks = 231608221292675